module.exports = __webpack_public_path__ + "static/media/docRight.6439570d.svg";